import { Component, Inject, Input, OnInit } from '@angular/core';

import { Formly, QUALIFICATION_FORMLY, QualificationService } from '@contact/upgrade';

@Component({
  selector: 'cng-contact-qualification',
  templateUrl: './contact-qualification.component.html',
  styleUrls: ['./contact-qualification.component.scss'],
  providers: [
    {
      provide: QUALIFICATION_FORMLY,
      useClass: Formly,
    },
  ],
})
export class ContactQualificationComponent implements OnInit {
  @Input() responseId: string;

  constructor(@Inject(QUALIFICATION_FORMLY) private readonly formly: Formly) {}

  ngOnInit() {
    this.formly.setId(QualificationService.toFormId(this.responseId));
  }
}
